const id = {
  menuRetryStrategy: "Retry Strategy",
  menuRetryStrategyPlan: "Plan",
  retryPlanTitle: "Retry Strategy Plan",
  retryPlanDescription:
    "Kelola rencana pengiriman ulang untuk broadcast yang gagal terkirim.",
  retryPlanListSearchCampaign: "Cari nama campaign",
  retryPlanFilterStatus: "Status",
  retryPlanStatusAll: "Semua",
  retryPlanListRowCount: "Tampilkan",
  retryPlanCreateButton: "Buat Plan Baru",
  retryPlanHeaderDisplayName: "Nama Plan",
  retryPlanHeaderDescription: "Deskripsi",
  retryPlanHeaderStatus: "Status",
  retryPlanHeaderCampaign: "Campaign",
  retryPlanHeaderLastModifier: "Terakhir Diubah",
  retryPlanHeaderAction: "Aksi",
  retryPlanStatusActive: "Aktif",
  retryPlanStatusInactive: "Tidak Aktif",
  retryPlanEmptyTitle: "Belum ada retry plan",
  retryPlanEmptyDescription:
    "Buat retry plan pertama Anda untuk mengirim ulang broadcast yang gagal.",
  failedGetRetryPlanListSnackbar:
    "Gagal memuat daftar retry plan. Silakan coba lagi.",
  retryPlanDeleteDialogTitle: "Hapus Retry Plan?",
  retryPlanDeleteDialogContent:
    "Plan {0} beserta konfigurasi kirim ulang beda hari campaign-nya akan dihapus dan tidak bisa dikembalikan.",
  retryPlanDeleteDialogCancel: "Batal",
  retryPlanDeleteDialogSubmit: "Hapus",
  successDeleteRetryPlanSnackbar: "Retry plan berhasil dihapus.",
  failedDeleteRetryPlanSnackbar:
    "Gagal menghapus retry plan. Silakan coba lagi.",
  retryPlanActivateDialogTitle: "Aktifkan Retry Plan?",
  retryPlanActivateDialogContent:
    "Hanya 1 plan aktif untuk setiap campaign. Mengaktifkan plan {0} akan menonaktifkan plan yang sedang aktif pada campaign {1}.",
  retryPlanActivateDialogSubmit: "Aktifkan",
  retryPlanDeactivateDialogTitle: "Nonaktifkan Retry Plan?",
  retryPlanDeactivateDialogContent:
    "Plan {0} akan dinonaktifkan. Campaign {1} tidak akan memiliki retry plan aktif.",
  retryPlanDeactivateDialogSubmit: "Nonaktifkan",
  successActivateRetryPlanSnackbar: "Retry plan berhasil diaktifkan.",
  failedActivateRetryPlanSnackbar:
    "Gagal mengaktifkan retry plan. Silakan coba lagi.",
  successDeactivateRetryPlanSnackbar: "Retry plan berhasil dinonaktifkan.",
  failedDeactivateRetryPlanSnackbar:
    "Gagal menonaktifkan retry plan. Silakan coba lagi.",
  retryPlanCreatePageTitle: "Buat Retry Plan",
  retryPlanCreatePageSubtitle:
    "Atur detail plan dan urutan pengiriman ulang broadcast.",
  retryPlanFormDetailsTitle: "Detail Plan",
  retryPlanFormNameLabel: "Nama Plan",
  retryPlanFormDescriptionLabel: "Deskripsi",
  retryPlanFormMediaTypeLabel: "Tipe Media",
  retryPlanFormCampaignLabel: "Diterapkan ke Campaign",
  retryPlanFormRetryableStatusLabel: "Status Retry",
  retryPlanRetryableFAI: "Setelah Gagal Terkirim",
  retryPlanRetryableNOA: "Setelah Tidak Ada Jawaban",
  retryPlanRetryableBSY: "Setelah Timeout",
  retryPlanRetryableStatusHint:
    "Retry hanya berjalan untuk pesan dengan status gagal. Pilih status gagal yang ingin di-retry.",
  retryPlanSequenceNeedCampaign:
    "Pilih campaign terlebih dahulu sebelum menambahkan step retry.",
  retryPlanFormRequired: "Wajib diisi",
  retryPlanFormInvalidCheckpoint:
    "Checkpoint tidak valid untuk tipe media ini. Pilih checkpoint yang sesuai.",
  retryPlanSequenceTitle: "Urutan Retry (Hari yang Sama)",
  retryPlanSequenceSubtitle:
    "Step berjalan berurutan pada hari yang sama dengan broadcast. Setiap step dijalankan jika percobaan sebelumnya tidak sampai ke penerima.",
  retryPlanSequenceEmpty: "Belum ada step. Tambahkan step retry pertama Anda.",
  retryPlanAddStepButton: "Tambah Step",
  retryPlanStepHeaderOrder: "Urutan",
  retryPlanStepHeaderType: "Tipe",
  retryPlanStepHeaderWaitTime: "Waktu Tunggu",
  retryPlanStepHeaderRetries: "Percobaan",
  retryPlanStepHeaderCampaign: "Campaign",
  retryPlanStepHeaderAction: "Aksi",
  retryPlanStepTypeInterval: "Interval",
  retryPlanStepTypeFixed: "Fixed",
  retryPlanStepDialogAddTitle: "Tambah Step Retry",
  retryPlanStepDialogEditTitle: "Ubah Step Retry",
  retryPlanStepTypeLabel: "Tipe Step",
  retryPlanStepIntervalHoursLabel: "Tunggu (jam)",
  retryPlanStepFixedTimeLabel: "Waktu kirim (besok)",
  retryPlanStepRetriesLabel: "Jumlah percobaan",
  retryPlanStepMediaTypeLabel: "Tipe Media",
  retryPlanStepCampaignLabel: "Gunakan Campaign",
  retryPlanStepHours: "{0} jam",
  retryPlanStepAttempts: "{0} percobaan",
  retryPlanStepSaveButton: "Simpan",
  retryPlanFormSaveButton: "Simpan",
  retryPlanFormCancelButton: "Batal",
  successCreateRetryPlanSnackbar: "Retry plan berhasil dibuat.",
  failedCreateRetryPlanSnackbar: "Gagal membuat retry plan. Silakan coba lagi.",
  partialCreateRetryStrategySnackbar:
    "Plan dibuat, tetapi {0} dari {1} step gagal disimpan.",
  retryPlanEditPageTitle: "Ubah Retry Plan",
  retryPlanStatusSectionTitle: "Status",
  retryPlanStatusActiveLabel: "Plan Aktif",
  retryPlanStatusActiveHint:
    "Diterapkan untuk mengirim ulang broadcast yang gagal pada campaign ini.",
  retryPlanLastModifiedLabel: "Terakhir diubah {0}",
  retryPlanModifiedByLabel: "oleh {0}",
  retryPlanSummaryTitle: "Ringkasan Alur Retry",
  retryPlanSummarySubtitle:
    "Gambaran bagaimana plan ini mengirim ulang broadcast yang gagal.",
  retryPlanSummaryTrigger:
    "Broadcast pada campaign {0} gagal dengan kondisi: {1}.",
  retryPlanSummaryTriggerNone:
    "Broadcast pada campaign {0} gagal dengan status retryable apa pun.",
  retryPlanSummaryStepInterval:
    "Tunggu ±{0} jam setelah percobaan sebelumnya, lalu kirim ulang via campaign {1} ({2}× berturut-turut).",
  retryPlanSummaryStepFixed:
    "Di hari yang sama pukul {0}, kirim ulang via campaign {1} (sekali; dilewati jika broadcast terkirim setelah pukul {0}).",
  retryPlanSummaryEnd:
    "Semua retry berhenti di akhir hari, meskipun masih ada percobaan yang gagal.",
  retryPlanSummaryEmpty:
    "Tambahkan step retry untuk melihat ringkasan alurnya.",
  customRetryTitle: "Kirim Ulang Beda Hari",
  customRetrySubtitle:
    "Kirim ulang penerima yang gagal sebagai batch baru beberapa hari kemudian via campaign lain.",
  customRetryEnableLabel: "Aktifkan kirim ulang beda hari",
  customRetrySelectCampaignHint:
    "Pilih campaign pada bagian Detail Plan terlebih dahulu.",
  customRetryConditionTitle: "Kondisi Retry",
  customRetryAttemptStatusLabel: "Status Percobaan",
  customRetrySuccessCheckpointLabel: "Checkpoint Sukses",
  customRetryTargetCampaignLabel: "Campaign Tujuan untuk Retry",
  customRetryRetryAfterLabel: "Kirim ulang setelah (hari)",
  customRetryModeLabel: "Mode",
  customRetryModeUniqueLabel: "Unique per day",
  customRetryModeUniqueHint: "Satu pengiriman ulang per hari per penerima.",
  customRetryModeDifferentLabel: "Different day",
  customRetryModeDifferentHint:
    "Pengiriman ulang dijadwalkan pada hari berbeda setelah broadcast.",
  customRetryBothActiveWarning:
    "Retry hari yang sama dan kirim ulang beda hari sama-sama aktif untuk campaign ini. Pastikan status retry tidak tumpang tindih agar penerima tidak dikirimi dua kali.",
  customRetrySelfLoopWarning:
    "Campaign tujuan sama dengan campaign sumber — kirim ulang akan masuk kembali ke campaign yang sama dan berisiko loop harian.",
  customRetryTargetSameAsSource:
    "Campaign tujuan harus berbeda dari campaign sumber.",
  customRetryCascadeWarning:
    "Campaign tujuan memiliki konfigurasi retry sendiri. Batch kirim ulang bisa di-retry lagi (efek berantai).",
  failedSaveCustomRetrySnackbar:
    "Plan tersimpan, tetapi konfigurasi kirim ulang beda hari gagal disimpan. Silakan coba lagi.",
  retryPlanSummaryMultiDayDifferent:
    "Hari +{0}: penerima berstatus {1} yang belum mencapai checkpoint {2} dikirim ulang sebagai batch baru via campaign {3}.",
  retryPlanSummaryMultiDayUnique:
    "Setiap hari: penerima yang gagal dikirim ulang sekali per hari via campaign {0}.",
  retryPlanSummaryEndWithMultiDay:
    "Retry hari yang sama berhenti di akhir hari; kirim ulang beda hari berlanjut sesuai jadwalnya.",
  successUpdateRetryPlanSnackbar: "Retry plan berhasil diperbarui.",
  failedUpdateRetryPlanSnackbar:
    "Gagal memperbarui retry plan. Silakan coba lagi.",
  partialUpdateRetryStrategySnackbar:
    "Plan diperbarui, tetapi {0} dari {1} perubahan step gagal disimpan.",
  retryPlanUnsavedChangesTitle: "Ada Perubahan Belum Tersimpan",
  retryPlanUnsavedChangesContent:
    "Anda memiliki perubahan yang belum disimpan. Yakin ingin meninggalkan halaman ini? Perubahan Anda akan hilang.",
  retryPlanUnsavedChangesLeave: "Tinggalkan",
  retryPlanUnsavedChangesStay: "Tetap di Sini",
};

const en = {
  menuRetryStrategy: "Retry Strategy",
  menuRetryStrategyPlan: "Plan",
  retryPlanTitle: "Retry Strategy Plan",
  retryPlanDescription: "Manage retry plans for failed broadcast deliveries.",
  retryPlanListSearchCampaign: "Search campaign name",
  retryPlanFilterStatus: "Status",
  retryPlanStatusAll: "All",
  retryPlanListRowCount: "Show",
  retryPlanCreateButton: "Create New Plan",
  retryPlanHeaderDisplayName: "Plan Name",
  retryPlanHeaderDescription: "Description",
  retryPlanHeaderStatus: "Status",
  retryPlanHeaderCampaign: "Campaign",
  retryPlanHeaderLastModifier: "Last Modified",
  retryPlanHeaderAction: "Action",
  retryPlanStatusActive: "Active",
  retryPlanStatusInactive: "Inactive",
  retryPlanEmptyTitle: "No retry plans yet",
  retryPlanEmptyDescription:
    "Create your first retry plan to resend failed broadcasts.",
  failedGetRetryPlanListSnackbar:
    "Failed to load retry plan list. Please try again.",
  retryPlanDeleteDialogTitle: "Delete Retry Plan?",
  retryPlanDeleteDialogContent:
    "Plan {0} and the campaign's multi-day re-broadcast config will be deleted and cannot be restored.",
  retryPlanDeleteDialogCancel: "Cancel",
  retryPlanDeleteDialogSubmit: "Delete",
  successDeleteRetryPlanSnackbar: "Retry plan deleted successfully.",
  failedDeleteRetryPlanSnackbar:
    "Failed to delete retry plan. Please try again.",
  retryPlanActivateDialogTitle: "Activate Retry Plan?",
  retryPlanActivateDialogContent:
    "Only 1 active plan is allowed per campaign. Activating plan {0} will deactivate the currently active plan for campaign {1}.",
  retryPlanActivateDialogSubmit: "Activate",
  retryPlanDeactivateDialogTitle: "Deactivate Retry Plan?",
  retryPlanDeactivateDialogContent:
    "Plan {0} will be deactivated. Campaign {1} will have no active retry plan.",
  retryPlanDeactivateDialogSubmit: "Deactivate",
  successActivateRetryPlanSnackbar: "Retry plan activated successfully.",
  failedActivateRetryPlanSnackbar:
    "Failed to activate retry plan. Please try again.",
  successDeactivateRetryPlanSnackbar: "Retry plan deactivated successfully.",
  failedDeactivateRetryPlanSnackbar:
    "Failed to deactivate retry plan. Please try again.",
  retryPlanCreatePageTitle: "Create Retry Plan",
  retryPlanCreatePageSubtitle:
    "Configure plan details and the broadcast retry sequence.",
  retryPlanFormDetailsTitle: "Plan Details",
  retryPlanFormNameLabel: "Plan Name",
  retryPlanFormDescriptionLabel: "Description",
  retryPlanFormMediaTypeLabel: "Media Type",
  retryPlanFormCampaignLabel: "Applied to Campaign",
  retryPlanFormRetryableStatusLabel: "Retryable Status",
  retryPlanRetryableFAI: "After Delivery Failed",
  retryPlanRetryableNOA: "After No Response",
  retryPlanRetryableBSY: "After Timeout",
  retryPlanRetryableStatusHint:
    "Retry runs only for messages with a failed status. Select which failed statuses to retry.",
  retryPlanSequenceNeedCampaign:
    "Select a campaign first before adding a retry step.",
  retryPlanFormRequired: "Required",
  retryPlanFormInvalidCheckpoint:
    "Invalid checkpoint for this media type. Select a valid checkpoint.",
  retryPlanSequenceTitle: "Same-Day Retry Sequence",
  retryPlanSequenceSubtitle:
    "Steps run in order on the same day as the broadcast. Each step triggers if the previous attempt didn't reach the recipient.",
  retryPlanSequenceEmpty: "No steps yet. Add your first retry step.",
  retryPlanAddStepButton: "Add Step",
  retryPlanStepHeaderOrder: "Order",
  retryPlanStepHeaderType: "Type",
  retryPlanStepHeaderWaitTime: "Wait Time",
  retryPlanStepHeaderRetries: "Retries",
  retryPlanStepHeaderCampaign: "Use Campaign",
  retryPlanStepHeaderAction: "Action",
  retryPlanStepTypeInterval: "Interval",
  retryPlanStepTypeFixed: "Fixed",
  retryPlanStepDialogAddTitle: "Add Retry Step",
  retryPlanStepDialogEditTitle: "Edit Retry Step",
  retryPlanStepTypeLabel: "Step Type",
  retryPlanStepIntervalHoursLabel: "Wait (hours)",
  retryPlanStepFixedTimeLabel: "Send time (next day)",
  retryPlanStepRetriesLabel: "Number of retries",
  retryPlanStepMediaTypeLabel: "Media Type",
  retryPlanStepCampaignLabel: "Use Campaign",
  retryPlanStepHours: "{0} hours",
  retryPlanStepAttempts: "{0} attempt(s)",
  retryPlanStepSaveButton: "Save",
  retryPlanFormSaveButton: "Save",
  retryPlanFormCancelButton: "Cancel",
  successCreateRetryPlanSnackbar: "Retry plan created successfully.",
  failedCreateRetryPlanSnackbar:
    "Failed to create retry plan. Please try again.",
  partialCreateRetryStrategySnackbar:
    "Plan created, but {0} of {1} steps failed to save.",
  retryPlanEditPageTitle: "Edit Retry Plan",
  retryPlanStatusSectionTitle: "Status",
  retryPlanStatusActiveLabel: "Active Plan",
  retryPlanStatusActiveHint:
    "Applied to retry failed broadcasts for this campaign.",
  retryPlanLastModifiedLabel: "Last modified {0}",
  retryPlanModifiedByLabel: "by {0}",
  retryPlanSummaryTitle: "How the Retry Works",
  retryPlanSummarySubtitle:
    "A walkthrough of how this plan resends failed broadcasts.",
  retryPlanSummaryTrigger: "A broadcast on campaign {0} fails with: {1}.",
  retryPlanSummaryTriggerNone:
    "A broadcast on campaign {0} fails with any retryable status.",
  retryPlanSummaryStepInterval:
    "Wait ~{0} hour(s) after the previous attempt, then resend via campaign {1} ({2}× in a row).",
  retryPlanSummaryStepFixed:
    "Same day at {0}, resend via campaign {1} (runs once; skipped if the broadcast went out after {0}).",
  retryPlanSummaryEnd:
    "All retries stop at the end of the day, even if attempts remain failed.",
  retryPlanSummaryEmpty: "Add retry steps to see the flow summary.",
  customRetryTitle: "Multi-Day Re-broadcast",
  customRetrySubtitle:
    "Resend failed receivers as a new batch days later via another campaign.",
  customRetryEnableLabel: "Enable multi-day re-broadcast",
  customRetrySelectCampaignHint:
    "Pick a campaign in the Plan Details section first.",
  customRetryConditionTitle: "Condition To Retry",
  customRetryAttemptStatusLabel: "Attempt with Status",
  customRetrySuccessCheckpointLabel: "Success Checkpoint",
  customRetryTargetCampaignLabel: "Target Campaign to Retry",
  customRetryRetryAfterLabel: "Retry after (days)",
  customRetryModeLabel: "Mode",
  customRetryModeUniqueLabel: "Unique per day",
  customRetryModeUniqueHint: "One resend per day per receiver.",
  customRetryModeDifferentLabel: "Different day",
  customRetryModeDifferentHint:
    "Resend scheduled on a different day after the broadcast.",
  customRetryBothActiveWarning:
    "Same-day ladder and per-day re-broadcast are both active for this campaign. Ensure retry statuses don't overlap, or receivers may be hit by both engines.",
  customRetrySelfLoopWarning:
    "Target campaign equals the source campaign — re-blasts feed back into the same campaign and risk a daily loop.",
  customRetryTargetSameAsSource:
    "Target campaign must differ from the source campaign.",
  customRetryCascadeWarning:
    "Target campaign has its own retry configuration. Re-broadcast batches may be retried again (cascade effect).",
  failedSaveCustomRetrySnackbar:
    "Plan saved, but the multi-day re-broadcast config failed to save. Please try again.",
  retryPlanSummaryMultiDayDifferent:
    "Day +{0}: receivers with status {1} that never reached checkpoint {2} are re-blasted as a new batch via campaign {3}.",
  retryPlanSummaryMultiDayUnique:
    "Every day: failed receivers are re-blasted once per day via campaign {0}.",
  retryPlanSummaryEndWithMultiDay:
    "Same-day retries stop at the end of the day; multi-day re-broadcast continues per its schedule.",
  successUpdateRetryPlanSnackbar: "Retry plan updated successfully.",
  failedUpdateRetryPlanSnackbar:
    "Failed to update retry plan. Please try again.",
  partialUpdateRetryStrategySnackbar:
    "Plan updated, but {0} of {1} step changes failed to save.",
  retryPlanUnsavedChangesTitle: "Unsaved Changes",
  retryPlanUnsavedChangesContent:
    "You have unsaved changes. Are you sure you want to leave? Your changes will be lost.",
  retryPlanUnsavedChangesLeave: "Leave",
  retryPlanUnsavedChangesStay: "Stay",
};

export default { id, en };
